export function mapAndFilterNulls<K, V>(ks: K[], fn: (t: K) => V | null): V[] {
  if (!ks) return [];
  return filterNulls(ks.map((k) => fn(k)));
}

export function filterNulls<K>(ks: (K | null)[]): K[] {
  return ks.filter((k) => k !== null) as K[];
}

export function nullIfFalsy<K>(k: K): K | null {
  if (k) return k;
  return null;
}

export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
